import styled from 'styled-components';
import { TabPanel as TabPanelBase } from '@mui/lab';
import { FlexColumn } from '@elementary/common-ui/components';
import { space } from '@elementary/common-ui/style/utils';
import type { IncidentDetail } from '../../types';
import IncidentExecutionHistoryTab from './IncidentExecutionHistoryTab';
import IncidentLineageTab from './IncidentLineageTab';
import IncidentMonitorsTab from './IncidentMonitorsTab';
import IncidentTimelineTab from './IncidentTimelineTab';

const TabsContainer = styled(FlexColumn)`
  height: 100%;
  min-height: 0;
  flex: 1;
  padding-top: ${space('sm')};
`;

const TabPanel = styled(TabPanelBase)`
  &[hidden] {
    display: none;
  }
  &:not([hidden]) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
`;

const ScrollableContent = styled(FlexColumn)`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

type Props = {
  incident: IncidentDetail;
};

const IncidentTabsPanel = ({ incident }: Props) => (
  <TabsContainer>
    <TabPanel value="execution">
      <ScrollableContent>
        <IncidentExecutionHistoryTab incident={incident} />
      </ScrollableContent>
    </TabPanel>

    <TabPanel value="lineage">
      <ScrollableContent>
        <IncidentLineageTab incident={incident} />
      </ScrollableContent>
    </TabPanel>

    <TabPanel value="monitors">
      <ScrollableContent>
        <IncidentMonitorsTab incident={incident} />
      </ScrollableContent>
    </TabPanel>

    <TabPanel value="timeline">
      <ScrollableContent>
        <IncidentTimelineTab incident={incident} />
      </ScrollableContent>
    </TabPanel>
  </TabsContainer>
);

export default IncidentTabsPanel;
